import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';
import { Header, NewsDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditUpdate = withRouter(props => {
  const history = useHistory();
  var com_id = props?.location?.pathname?.split('/')?.[2]??null;
  const classes = useStyles();
  const [newsobj, setNewsobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const [masters, setMasters] = useState({
    commodity :[]
  });

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);

  async function fetchmasters()
  {
    let masterlanguages = [
      {
        id : 0,
        name: "All",
        shortcode: "All",
        priority : "All",
        status: true
      }
    ]
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    setMasters({
      ...masters,
      languages : masterlanguages.concat(languages.module),
      commodity : commodities.module

    })
  }
  async function updatenewsinfo(newsinfo){
     let response = await sendNetworkRequest('/admin/addupdate', {}, newsinfo,false)
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: "success",
        msg: response.message,
        vertical: "top",
      });
      history.push("/updates");
  }
  async function fetchcommodityinfo(newsid)
  {
    let commodities = await sendNetworkRequest('/admin/getupdateinfo', {}, {id: newsid},false)
    let language = [];
    let commodity = [];
    let updatecontent = {}
    let commodityobj = commodities?.module;
    let update_languages = commodityobj?.update_languages
    let update_commodity = commodityobj?.update_commodities
    update_languages.map(item => {
      language.push(item.master_language);
      updatecontent['name'+item?.master_language?.name] = item?.title
      updatecontent['desc'+item?.master_language?.name] = item?.description
    })
    update_commodity.map(item => {
      commodity.push(item.master_commodity);
    })
    let newsobj = {
          ...updatecontent,
           id : commodityobj.id,
           imageurl: commodityobj.imageurl,
           pdfurl : commodityobj.pdfurl,
          commodity : commodity,
          language
      }

      setNewsobj(newsobj)
   
  }
  useEffect(() => {
     var com_id = props.location.pathname.split('/')[2];
    // var viewtype = props.location.pathname.split('/')[3];
    // setViewtype(viewtype)
    // setUserid(user_id)
    fetchmasters()

    if(com_id)
    {
      setViewtype(2)
    fetchcommodityinfo(com_id);
    }else{
      setViewtype(1)
    }
    
  }, []);

  return (
    <Page
      className={classes.root}
      title="Futures"
    >
      <Header isEdit={com_id}/>
     <NewsDetails isEdit={com_id} usercontent={newsobj} masters={masters} viewtype={viewtype} onSave={updatenewsinfo}/> 
     
    </Page>
  );
});

export default EditUpdate;
